export const zh = {
    welcome: '歡迎！',
    moreThan18years: '您是否已年滿 18 歲？',
    yes: '叉子',
    no: '不',
    institutional : '機構',
    OurBrands: '我們的品牌',
    EcoSustainableCommitment: '生態永續承諾',
    MadeForYou: '為您量身打造',
    paisCarrousel1: '一杯自己的苦艾酒',
    paisCarrousel2: '由故事組成',
    peregrinoCarrousel1: '每一刻都值得喝一杯琴酒',
    peregrinoCarrousel2: '三種享受方式',
    atonitoCarrousel1: '讓自己驚喜',
    atonitoCarrousel2: '第一款優質 Entre Ríos 苦啤酒',
    factoryCarrousel1: '每個瓶子都說著一個故事',
    factoryCarrousel2: '精選原料及手工藝。',
    btnViewProducts: '看完整目錄',
    historyTitle:'我們的歷史',
    historySubtitle:'我們的工廠，我們的家，您的家。',
    histoyText1: '1992 年，在兩位擁有相同職業和經驗的朋友的巨大個人努力下，ABA SRL 成立，這是一家致力於飲料生產的公司。',
    historyText2: 'ABA 復興了恩特雷裡奧斯古老的開胃酒傳統，並向公眾推出了 YATAY 開胃酒，採用與前輩相同的方法和配方製作而成。這項事業立即獲得了消費者的支持，多年來，它致力於開發新的開胃酒和利口酒。到 2020 年，ABA 的產品組合已包括 13 種產品，包括 Yatay Americano 和開胃酒、Fernet Maggiore 和 Lezard 系列利口酒。今年，該國和該地區的酒精飲料消費經歷了重大的範式轉移。這是該公司的一個轉捩點，該公司自此開發了 20 多種新產品。近年來在國內市場獲得的認可，加上在口味和香氣方面取得的平衡，一方面關注和尊重傳統口味，另一方面創新和開發一些原創口味，始終以草藥、原材料為基礎，所有相關人員熱情工作，確保產品的最高質量，激勵公司和美食領袖選擇 ABA 來生產自己的產品。為此，目前透過開發新的業務部門“客製化生產”，為第三方生產超過 15 種產品。',
    historyText3: '自 1992 年以來，我們一直致力於不斷改進內部流程，並始終將客戶滿意度作為我們的首要任務。',
    factory: '工廠',
    advantageTitle: '我們有何不同？',
    advantageSubtitle1: '超過 30 年的專業知識',
    advantageSubtitle2: '持續改進和流程自動化',
    advantageSubtitle3: '先進的技術和生產能力',
    advantageText1:'缺文字',
    advantageText2:'缺文字',
    advantageText3:'缺文字',
    btnHistory:'看更多',
    cocktails:'雞尾酒',
    GinTonic: '金湯力',
    Atonik:'Atonik',
    Vermút:'苦艾酒',
    ingredientsGinTonic: 'Peregrino 金酒、湯力水、檸檬',
    ingredientsAtonik: '驚訝，滋補，橙色',
    ingredientsVermut: '苦艾酒派斯、蘇打水、橘子',
    btnReceipt:'完整食譜',
    footerInit: '首頁',
    footerInstitutional: '機構',
    footerOurBrands:'我們的品牌',
    contact:'接觸',
    socialNetworking:'社群網路',
    Email: '電子郵件',
    cellPhone:'電話',
    close: '關閉',
    ProductCatalog:'產品目錄',
    FollowUsOnOurNetworks: '在我們的網路上關注我們',
    peregrinoFrase1: '每一刻都值得一杯琴酒',
    peregrinoFrase2: '三種享受方式',
    peregrinoGoldenTitle: '永遠的經典',
    peregrinoGoldenText: '乾杜松子酒，香氣和味道均帶有柑橘味。由恩特雷裡奧斯柑橘類水果製成，包括橙子、橘子和葡萄柚，與盧塞拉葡萄一起使我們的杜松子酒成為本地產品。在純手工生產過程中，也使用了來自阿根廷巴塔哥尼亞的杜松子和穀類酒精。其他植物成分包括香菜、小荳蔻、當歸根、胡椒和肉桂。金色杜松子酒：我們的杜松子酒的金色是透過與某些植物進行最後的水醇浸漬而實現的。',
    peregrinoPinkTitle: '紅色水果的香氣和淡淡的色彩。',
    peregrinoPinkText: '我們的 Pink Peregrino 以金色 Peregrino 為基礎，添加紅色水果製成，其中主要為黑莓和藍莓。芳香花香，不添加糖，紅色水果的甜味帶來清新口感。粉紅杜松子酒：其明亮的莧菜餚與湯力水混合後會變成淡淡的粉紅色。',
    peregrinoBlackTitle: '深邃的優雅。',
    peregrinoBlackText: '杜松子酒和菲奈特酒以適當的比例混合，製成了我們的黑杜松子酒。由我們的 Golden Gin 和 Fernet Maggiore 釀造而成，均為 100% 手工製作。這是一種含有 50 多種植物成分的杜松子酒。在市場上獨樹一幟，那些想要擺脫傳統的人會發現 Peregrino Black 具有多種口味組合，既能吸引味蕾，又不失我們產品的精髓：以當地植物為主導。黑杜松子酒：菲奈特的存在賦予了它最終濃鬱的黑色。',
    peregrinoSection1: '超過 10 種植物成分融合成了一種口感柔滑、柑橘味十足的杜松子酒，正在阿根廷各地銷售。',
    peregrinoSection2: '每一瓶 Peregrino 都講述著一個故事：精選的原料、手工藝和阿根廷日落的色彩。',
    peregrinoSection3Title:'朝聖',
    peregrinoSection4Title:'盒子和玻璃器皿',
    peregrinoMoments: '朝聖時刻',
    ginFizz: 'Gin Fizz',
    ingredientsGinFizz: 'Peregrino 金酒、檸檬汁、糖、薄荷',
    lemonGin: 'LemonGin',
    ingredientsLemonGin: 'Peregrino 金酒、湯力水、檸檬冰淇淋、薄荷',
    atonitoTitle:'第一款優質 Entre Ríos 苦啤酒',
    atonitoText1:'自 2021 年以來，精心挑選的植物成分的優良組合為第一款優質 Entre Ríos 開胃酒注入了活力。',
    atonitoSection1Title:'恩特雷裡奧斯柑橘',
    atonitoSection1Text:'其中，柳橙、柑橘、葡萄柚和檸檬特別突出，它們是我們苦啤酒獲得獨特風味並讓您完全驚嘆的關鍵之一。',
    atonitoSection2Text:'Atónito 誕生於傳統，誕生於朋友間的聚會，誕生於不斷流傳的習慣。因此，開胃菜已融入阿根廷人的基因。',
    garibaldi:'Garibaldi',
    ingredientsGaribaldi:'驚訝, 橙汁, 橙片',
    paistText1: '在移民的土地上，開胃酒的傳統比以往任何時候都更加鮮活，用故事、精心挑選的本地植物和純手工的生產方法製成，真正的阿根廷苦艾酒 Vermut País 誕生了。',
    paisText2: '以中性白酒手工釀造，加入 20 多種植物成分',
    paisSection1Title: '延續的傳統',
    paisSection1Text: '一百多年前，一位南斯拉夫移民來到我們的城市，帶來了一道開胃菜的食譜，從此改變了烏拉圭和阿根廷的格局。如今，ABA S.R.L.保留了恩特雷裡奧斯省以及全國各地飲用開胃酒的傳統。 Vermut PAÍS 讓您回到過去。 País Rosso 是一種都靈風格的苦艾酒。採用中性白葡萄酒、柑橘類水果以及主要來自美索不達米亞的植物（如艾蒿、甘草、當歸根結底和金雞納樹）製成，它們在口感上達到了甜味和苦味之間的完美平衡。',
    paisSection2Title: '同樣的傳統。新格式',
    paisSection2Text: 'ABA 有限公司決定在創新方面邁出一步，讓消費者能夠買到即飲的 Vermut País。就這樣，它推出了 Vermut Rosso + 蘇打水和 Vermut Rosso + 葡萄柚版本。',
    paissection3Title: '在你的國家',
    negroniAba: 'Negroni ABA',
    ingredientsNegroniAba: '金色琴酒、紅苦艾酒和驚訝紅苦酒',
    CaringForTheEnvironment: '關懷環境',
    CaringForTheEnvironmentText: '環境管理和在所有過程中有意識、合理地使用自然資源是 ABA 日常工作的根本支柱。自成立以來，我們一直致力於減少對環境的破壞，而這種努力日益加強。我們所有的容器都是玻璃製成的，並且我們有一個回收廢棄瓶子的當地計劃。為了實現這一目標，ABA 採用了洗瓶機，這使我們能夠優化用水量。',
    ProductionAndFashion: '客製化生產',
    ProductionAndFashionText: '2021 年，隨著我們第一位客戶/業務合作夥伴的出現，我們成立了新的業務部門：客製化生產。如今，我們有五位客戶，我們為他們開發了各種產品，以滿足他們的需求，並符合最高的品質標準，例如杜松子酒、苦艾酒、開胃酒、菲奈特酒、椰子蘭姆酒和美式咖啡。'


}